// extracted by mini-css-extract-plugin
module.exports = {"error":"lodging_error__3sn6a","accommodation":"lodging_accommodation__1d4jT","header":"lodging_header__WS6I9","offerList":"lodging_offerList__7EgS-"};